import React, { useEffect } from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  GDSStyleObject,
  UtilityText,
  Card,
  HeadingText,
  StackLayout,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { COB_LIBRARY_ASSET_KEYS } from '../../../types/cob-library.types';
import COBQuestioner from '../../../assets/json/COB_QUESTIONER.json';
import './instruction.css';

export function FormInstruction(props: any) {
  // eslint-disable-next-line react/prop-types
  const { errorHandling, nextButtonClicked } = props;
  const isBelow400 = useMediaQuery(queryHelpers.down(400));
  const isBetween300And700 = useMediaQuery(queryHelpers.between([300, 800]));

  const is360 = useMediaQuery(queryHelpers.down(390));
  useEffect(() => {
    if (nextButtonClicked) {
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  }, [errorHandling, nextButtonClicked]);

  interface Instruction {
    INSURANCECARD: string;
    MEDICALCARD: string;
    RENALDISEASE: string;
  }
  const instructionList: Instruction =
    COBQuestioner.COB.FORMINSTRUCTION.INSTRUCTIONLIST;

  return (
    <StackLayout
      horizontalAlignment="center"
      css={
        {
          backgroundColor: 'White',
          maxWidth: '480px',
          borderRadius: '9px',
          '@mobile': { height: '785px' },
          '@desktop': { height: '100%', width: '480px' },
          '@laptop': { height: '100%' },
          '@mobileLandscape': { height: '730px' },
          '@tablet': { height: '100%' },
        } as GDSStyleObject
      }
      data-testid="FormInstructionLayout"
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '$none $none',
            marginTop: '-8px',
            minHeight: '500px',
          } as GDSStyleObject
        }
      >
        <Card.Flat
          css={{
            maxWidth: '480px',
            minHeight: '500px',
            border: '0px solid',
            '@mobile': {
              paddingLeft: isBelow400 ? '0px' : '10px',
              paddingRight: isBelow400 ? '0px' : '10px',
              width: isBelow400 ? '360px' : '452px',
            },
            '@desktop': { width: '480px' },
            '@laptop': { width: '480px' },
            '@mobileLandscape': { width: '480px' },
            '@tablet': { width: '480px' },
          }}
        >
          <Card.Image
            image={
              useStaticAsset(
                COB_LIBRARY_ASSET_KEYS.FORM_INSTRUCTION_DIVIDER,
              ) as string
            }
            imageAlt="Other Insurance Information/COB"
          />
          <Card.Section>
            <HeadingText
              size="md"
              level="4"
              css={
                {
                  fontSize: '$headingOne',
                  padding: '$none $none $none $none',
                  marginLeft: '12px',
                  lineHeight: '33px',
                } as GDSStyleObject
              }
            >
              {COBQuestioner.COB.FORMINSTRUCTION.TITLE}
            </HeadingText>
          </Card.Section>
          <Box
            css={
              {
                marginBottom: '10px',
                paddingLeft: '32px',
                paddingRight: '32px',
                textAlign: 'justify',
              } as GDSStyleObject
            }
          >
            <UtilityText
              css={
                {
                  lineHeight: '20px',
                  marginBottom: '10px',
                  textAlign: 'justify',
                  paddingRight: '20px',
                } as GDSStyleObject
              }
            >
              {COBQuestioner.COB.FORMINSTRUCTION.CONTENT}
            </UtilityText>
          </Box>
          <Box
            css={
              {
                marginBottom: '10px',
                paddingRight: '32px',
                paddingLeft: '32px',
              } as GDSStyleObject
            }
          >
            <UtilityText
              css={
                {
                  lineHeight: '20px',
                } as GDSStyleObject
              }
            >
              {COBQuestioner.COB.FORMINSTRUCTION.SUBCONTENT}
            </UtilityText>
          </Box>
          <Box
            css={
              {
                marginLeft: '32px',
                marginRight: '32px',
                '@mobile': {
                  width: isBelow400 ? '308px' : '',
                },
              } as GDSStyleObject
            }
          >
            <ul
              style={{
                lineHeight: '23px',
                listStyle: 'disc',
                textAlign: 'left',
                width: isBelow400 ? '290px' : '340px',
                marginLeft: isBetween300And700 ? '25px' : '25px',
              }}
            >
              {Object.entries(instructionList).map(([key, list]) => (
                <li style={{ marginBottom: '5px' }} key={key}>
                  {list}
                </li>
              ))}
            </ul>
          </Box>
          <Box
            id="box-empty"
            css={{
              width: isBelow400 ? '375px' : '460px',
              height: '70px',
              backgroundColor: '$surfaceCardPrimary',
              marginTop: '20px',
              marginBottom: '10px',
              paddingLeft: '32px',
              paddingTop: '5px',
              paddingRight: '32px',
              textAlign: 'justify',
              '@mobile': {
                marginLeft: !is360 ? '0px' : '0px',
                width: !is360 ? '374px' : '440px',
              },
            }}
          >
            <Box
              id="box-empty"
              css={{
                width: '10px',
                height: '58px',
                backgroundColor: '$decorativeBrandPrimaryBrightest',
                float: 'left',
                borderColor: '$decorativeBrandPrimaryBrightest',
                borderRadius: '$medium',
              }}
            />
            <Box
              id="box-empty"
              css={{
                width: '20px',
                height: '58px',
                backgroundColor: '$surfaceCardPrimary',
                float: 'left',
              }}
            />
            <Box
              id="box-empty"
              css={{
                height: '58px',
                backgroundColor: '$surfaceCardPrimary',
                marginTop: '0px',
                textAlign: 'left',
                lineHeight: '15px',
                maxWidth: isBelow400 ? '280px' : '385px',
              }}
            >
              <UtilityText
                css={{
                  lineHeight: '28.8px',
                  fontSize: '$headingThree',
                  fontWeight: '400',
                }}
              >
                {COBQuestioner.COB.FORMINSTRUCTION.DISCLAIMER}
              </UtilityText>
            </Box>
          </Box>
          {/* </Box>
          </Card.Section> */}
        </Card.Flat>
      </Box>
    </StackLayout>
  );
}
